'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import {
  FaArrowLeft,
  FaFacebookF,
  FaInstagram,
  FaXmark,
  FaYoutube,
} from 'react-icons/fa6';
import HeaderClient from './HeaderClient';
import HeaderCart from './HeaderCart';
import BrowseCategories from '@/features/header/BrowseCategories';
import SearchComponent from './SearchComponent';
import DiscountHeader from './DiscountHeader';
import SidebarAction from './SidebarAction';
import MobileMenuItem from './MobileMenuItem';
import ClientImage from './ClientImage';

const menuData = [
  { title: 'Shop', href: '/shop' },
  { title: 'Blogs', href: '/blogs' },
  { title: 'Contact Us', href: '/contact' },
  { title: 'FAQ', href: '/faq' },
  { title: 'Kirei Community', href: '/community' },
  { title: 'About Us', href: '/about-us' },
  { title: 'Kirei Tube', href: '/kirei-tube' },
  { title: 'Return & Refund', href: '/return-refund' },
  { title: 'Terms & Condition', href: '/term-condition' },
  { title: 'Testimonials', href: '/testimonials' },
  { title: 'Responsible Disclosure', href: '/responsible-disclosure' },
];

const socialKeys = [
  'facebook_link',
  'instagram_link',
  'youtube_link',
  'hot_deals_start_datetime',
  'hot_deals_end_datetime',
];

const Header = ({ data, sidebarData }: any) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isHotDealActive, setIsHotDealActive] = useState(false);

  const socialData = data?.data?.reduce((acc: any, item: any) => {
    if (socialKeys.includes(item.type) && item.value) {
      acc[item.type] = item.value;
    }
    return acc;
  }, {});

  // Data processing logic
  const topBarMessage = data?.data?.filter(
    (item: any) => item?.type === 'topbar_message'
  );

  useEffect(() => {
    if (
      socialData?.hot_deals_start_datetime &&
      socialData?.hot_deals_end_datetime
    ) {
      const today = new Date();
      setIsHotDealActive(
        today >= new Date(socialData.hot_deals_start_datetime) &&
          today <= new Date(socialData.hot_deals_end_datetime)
      );
    }
  }, [socialData]);

  // const todaysDate = new Date();
  // const isHotDealActive =
  //   todaysDate >= new Date(socialData?.hot_deals_start_datetime) &&
  //   todaysDate <= new Date(socialData?.hot_deals_end_datetime);

  // topbarmassage existence check
  const isTopBarVisible = !!topBarMessage?.[0]?.value;
  // const isTopBarVisible = false;

  // Lock body scroll when menu is open
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMenuOpen]);

  return (
    <HeaderClient isMenuOpen={isMenuOpen}>
      <header className={`header ${isMenuOpen ? 'is-menu-open' : ''}`}>
        {/* Top Section (Desktop Only) */}
          {isTopBarVisible && (
            <DiscountHeader data={topBarMessage?.[0]?.value} />
          )}
        <div className="header-nav-container d-none d-xl-block">
          <div className="header-top">
            <div className="container">
              <div className="header-top__wrapper">
                <div className="header__brand">
                  <Link href="/">
                    <ClientImage
                      width={110}
                      height={77}
                      src="/images/logo/logo.svg"
                      alt="logo"
                      priority
                    />
                    {/* <Image
                      width={110}
                      height={77}
                      src="/images/logo/logo.svg"
                      alt="logo"
                      priority
                    /> */}
                  </Link>
                </div>
                <SearchComponent />
                <div className="header__contact">
                  <div className="header__contact-thumb">
                    <ClientImage
                      width={41}
                      height={41}
                      src="/images/social/phone.png"
                      alt="support"
                    />

                    {/* <Image
                      height={41}
                      width={41}
                      src="/images/social/phone.png"
                      alt="support"
                    /> */}
                  </div>
                  <div className="header__contact-number">
                    <span>Support</span>
                    <h6 className="mb-0 fw-medium">
                      <Link href="tel:+8809666791110">+880 966 679 1110</Link>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className={`header-bottom ${isMenuOpen ? 'is-menu-open' : ''}`}>
          <div className="container">
            <div className="header-bottom__wrapper">
              {/* Mobile Brand & Trigger */}
              <div className="header__brand d-xl-none">
                <div className="d-flex align-items-center gap-3">
                  <button
                    type="button"
                    className="menu-mobile-trigger"
                    onClick={() => setIsMenuOpen(true)}
                  >
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                  </button>
                  <Link href="/">
                    {/* <img src="/images/logo/logo.svg" alt="logo" style={{ maxWidth: '80px' }} /> */}
                    {/* <Image
                      width={80}
                      height={40}
                      src="/images/logo/logo.svg"
                      alt="logo"
                      style={{ maxWidth: '80px', height: 'auto' }}
                    /> */}
                    <ClientImage
                      width={80}
                      height={40}
                      src="/images/logo/logo.svg"
                      alt="logo"
                    />
                  </Link>
                </div>
              </div>

              <BrowseCategories
                data={sidebarData}
                hasTopBar={isTopBarVisible}
                // isSticky={true}
              />

              {/* Sidebar / Navbar */}
              <div className="header__navbar">
                {/* Overlay */}
                <div
                  className={`header__overlay ${isMenuOpen ? 'active' : ''}`}
                  onClick={() => setIsMenuOpen(false)}
                />

                <nav
                  className={`menu menu-mobile ${isMenuOpen ? 'active' : ''}`}
                >
                  <div className="menu-mobile-header">
                    <button
                      type="button"
                      className="menu-mobile-arrow"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <FaArrowLeft />
                    </button>
                    <div className="menu-mobile-title">
                      <Link href="/">
                        {/* <img src="/images/logo/logo.svg" alt="logo" /> */}
                        {/* <Image
                          width={80}
                          height={40}
                          src="/images/logo/logo.svg"
                          alt="logo"
                          style={{ maxWidth: '80px', height: 'auto' }}
                        /> */}
                        <ClientImage
                          width={80}
                          height={40}
                          src="/images/logo/logo.svg"
                          alt="logo"
                        />
                      </Link>
                    </div>
                    <button
                      type="button"
                      className="menu-mobile-close"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      <FaXmark />
                    </button>
                  </div>

                  {/* Desktop Menu Links */}
                  <ul className="menu-section desktop-menu-section d-none d-xl-flex">
                    <li>
                      <Link href="/">Home</Link>
                    </li>
                    {isHotDealActive && (
                      <li>
                        <Link href="/hot-deals">Hot Deals</Link>
                      </li>
                    )}
                    <li>
                      <Link href="/shop">Shop</Link>
                    </li>
                    <li>
                      <Link href="/blogs">Blogs</Link>
                    </li>
                    <li>
                      <Link href="/contact">Contact</Link>
                    </li>
                  </ul>

                  {/* Mobile Sidebar Content */}
                  <div className="d-xl-none">
                    <div className="header__support my-4 px-4">
                      <div className="d-flex align-items-center justify-content-center gap-3 py-1 px-3 border rounded-3">
                        {/* <Image
                          src="/images/social/phone.png"
                          alt="support"
                          height={41}
                          width={41}
                        /> */}
                        <ClientImage
                          width={41}
                          height={41}
                          src="/images/social/phone.png"
                          alt="support"
                        />
                        <div className="header__support-number">
                          <span>Support</span>
                          <h4 className="mb-0 fw-semibold">
                            +880 966 679 1110
                          </h4>
                        </div>
                      </div>
                    </div>

                    {/* <ul className="menu-section mobile-menu-section">
                      <MobileMenuItem item={{ title: 'Home', href: '/' }} />
                      {sidebarData?.sidebarList?.map((item: any, index: number) => (
                        <MobileMenuItem item={item} key={`sidebar-${index}`} />
                      ))}
                      {menuData.map((item, index) => (
                        <MobileMenuItem item={item} key={`menu-${index}`} />
                      ))}
                    </ul> */}

                    {/* // Inside Header.tsx, update the mapping: */}
                    <ul className="menu-section mobile-menu-section">
                      <MobileMenuItem
                        item={{ title: 'Home', href: '/' }}
                        onClose={() => setIsMenuOpen(false)}
                      />
                      {sidebarData?.sidebarList?.map(
                        (item: any, index: number) => (
                          <MobileMenuItem
                            item={item}
                            key={`sidebar-${index}`}
                            onClose={() => setIsMenuOpen(false)}
                          />
                        )
                      )}
                      {menuData.map((item, index) => (
                        <MobileMenuItem
                          item={item}
                          key={`menu-${index}`}
                          onClose={() => setIsMenuOpen(false)}
                        />
                      ))}
                    </ul>

                    <div className='mb-5'></div>

                    {/* <div className='pb-5 mb-5'>
                      <SidebarAction />
                    </div> */}

                    {/* <div className="sidebar-social pt-4 pb-5 d-flex justify-content-center">
                      <ul className="social d-flex gap-3">
                        <li>
                          <a
                            href={socialData?.facebook_link}
                            target="_blank"
                            className="social__link"
                          >
                            <FaFacebookF />
                          </a>
                        </li>
                        <li>
                          <a
                            href={socialData?.youtube_link}
                            target="_blank"
                            className="social__link"
                          >
                            <FaYoutube />
                          </a>
                        </li>
                        <li>
                          <a
                            href={socialData?.instagram_link}
                            target="_blank"
                            className="social__link"
                          >
                            <FaInstagram />
                          </a>
                        </li>
                      </ul>
                    </div> */}

                  </div>
                </nav>
              </div>

              <div className="header__action">
                <HeaderCart />
              </div>
            </div>

            {/* Mobile Search Bar */}
            <div className="d-xl-none mt-3">
              <SearchComponent />
            </div>
          </div>
        </div>
      </header>
    </HeaderClient>
  );
};

export default Header;
